import { render } from "./AttendanceAdjustmentPage.vue?vue&type=template&id=bf058496"
import script from "./AttendanceAdjustmentPage.vue?vue&type=script&lang=js"
export * from "./AttendanceAdjustmentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__